import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.css']
})
export class InvoiceDetailsComponent implements OnInit {

  constructor(private invoiceService:ServiceService) { }
 
  output:any=[]; //---store get() result--------
  invoiceId='';
  //getUrl='http://192.241.151.66:5000/viewInvoices';
  Total_sales=''
  number=""
  //-------date formating-------------
  today: Date = new Date();
  pipe = new DatePipe('en-US');
  DateAndTime:any= null;
  ngOnInit(): void {

     //---call function in service for invoice Id------
     this.invoiceId=this.invoiceService.getInvoiceId()
     
 
    //-------api get()calling-------------
    this.invoiceService.InvoiceDetails('/'+this.invoiceId).subscribe((res)=>{
      this.output=res.data
      this.Total_sales=res.total_sales_value
      this.number=this.output[0].invoice_number
    //-------date formating----------------------
     this.DateAndTime = this.pipe.transform(this.output[0].date_time, 'MMM d, y, h:mm:ss a');
     console.log("customer details =",this.output)
 
    })
  }

}
